<script>
export default {
	name: 'AqField',
	props: {
		label: {
			type: String,
			default: '',
		},
		required: {
			type: Boolean,
			default: false,
		},
		invalid: {
			type: Boolean,
			default: false,
		},
		error: {
			type: String,
			default: '',
		},
		hint: {
			type: String,
			default: '',
		},
		autofilled: {
			type: Boolean,
			default: false,
		},
		wide: {
			type: Boolean,
			default: false,
		},
	},
}
</script>

<template>
	<div class="aq-field" :class="{ 'is-invalid': invalid, 'is-auto': autofilled, 'aq-field--wide': wide }" :data-invalid="invalid || null">
		<span v-if="label" class="aq-field__label">
			{{ label }}<span v-if="required" class="aq-field__required" aria-hidden="true">*</span>
			<span v-if="autofilled" class="aq-field__auto">
				<svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4">
					<path d="M5 12.5l4.5 4.5L19 7" />
				</svg>
				{{ $t('aqua.ui.autofilled') }}
			</span>
		</span>
		<slot />
		<span v-if="invalid" class="aq-field__error" role="alert">{{ error || $t('aqua.ui.required') }}</span>
		<span v-else-if="hint" class="aq-field__hint">{{ hint }}</span>
	</div>
</template>

<style scoped>
.aq-field {
	display: flex;
	flex-direction: column;
	gap: 6px;
	min-width: 0;
}
.aq-field--wide {
	grid-column: 1 / -1;
}
.aq-field__label {
	display: block;
	font-size: 13px;
	font-weight: 500;
	line-height: 1.35;
	color: var(--aq-ink-2);
}
.aq-field__required {
	margin-left: 2px;
	color: var(--aq-danger);
}
.aq-field__auto {
	display: inline-flex;
	margin-left: 6px;
	vertical-align: 1px;
	align-items: center;
	gap: 3px;
	padding: 1px 8px;
	border-radius: 999px;
	background: var(--aq-success-soft);
	color: var(--aq-success);
	font-size: 11px;
	font-weight: 600;
}
.aq-field__error {
	font-size: 12px;
	color: var(--aq-danger);
}
.aq-field__hint {
	font-size: 12px;
	color: var(--aq-muted);
}
.aq-field.is-invalid ::v-deep .aq-input,
.aq-field.is-invalid ::v-deep .multiselect__tags,
.aq-field.is-invalid ::v-deep .aq-select__control {
	border-color: var(--aq-danger) !important;
	background: #fffafa;
}
.aq-field.is-auto ::v-deep .aq-input {
	border-color: #9ad8b6;
	background: #f6fcf8;
}
</style>
